import { useMutation } from "react-query"
import api from "../client"
import { queryClient, queryKeys } from "../query"
import { UpdateOrderLoadingPaylod, UpdateOrderLoadingResponseData } from "../types/order"

const patchData = async (uuid: string | undefined, payload: UpdateOrderLoadingPaylod) => {
    const { data } = await api.patch<UpdateOrderLoadingResponseData>(
        `/orders/${uuid}`,
        payload
    )

    queryClient.invalidateQueries(queryKeys.ORDER(uuid))
    queryClient.invalidateQueries(queryKeys.ORDER_SUMMARY(uuid), { refetchInactive: true })
    queryClient.invalidateQueries(["orders"], { refetchInactive: true })

    if (payload.loading.useAsLoadingDefaultAddress) {
        queryClient.invalidateQueries(["user"], { refetchInactive: true })
    }

    return data
}

export const useUpdateLoading = (uuid: string | undefined) => {
    return useMutation((payload: UpdateOrderLoadingPaylod) => {
        return patchData(uuid, payload)
    })
}
